import { Avatar, Flex, Text } from "@mantine/core";
import type { FC } from "react";
import { memo } from "react";
import { MdLightbulbOutline } from "react-icons/md";

import styles from "./RankingItem.module.scss";

type RankingItemProps = {
  avatar: string;
  description: string;
  name: string;
  nice: number;
  ranking: number;
};

// TODO:ランキングページ作成後、不必要な場合削除
// 表示確認用ダミーコンポーネント
const RankingItem: FC<RankingItemProps> = ({
  avatar,
  description,
  name,
  nice,
  ranking,
}) => {
  return (
    <div className={styles.ranking}>
      <Flex align="center">
        <div className={styles.rankingNumber}>{ranking}</div>
        <div className={styles.avatarWrap}>
          <Avatar src={avatar} />
        </div>

        <div className={styles.rankingTexts}>
          <Text size={12}>{name}</Text>
          <Text size={12} className={styles.description}>
            {description}
          </Text>
        </div>
        <Flex
          align="center"
          justify="space-between"
          className={styles.niceWrap}
        >
          <MdLightbulbOutline size={20} />
          <Text size={16}>{nice}</Text>
        </Flex>
      </Flex>
    </div>
  );
};

export const RankingItemMemo = memo(RankingItem);
